import { ExclamationCircleIcon } from '@heroicons/react/24/outline'

export const FormError = ({ error }) => {
  if (!error) return null

  return (
    <div className='rounded-md bg-red-50'>
      <div className='flex'>
        <ExclamationCircleIcon className='h-5 w-5 text-[--error]' aria-hidden='true' />
        <div className=''>
          <p className='text-sm text-[--error]'>{error}</p>
        </div>
      </div>
    </div>
  )
}
